import Auth from '@aws-amplify/auth';
import { Log, Logger } from './logger';

const log: Logger = Log({ source: 'authentication' });

export const ForgotPassword = async ({ username }: { username: string }): Promise<boolean> => {
  await Auth.forgotPassword(username).catch((err) => {
    if (err.code === 'UserNotFoundException') {
      throw new Error('Username not found.');
    }

    if (err.code === 'LimitExceededException') {
      throw new Error('Password reset attempt limit exceeded. Please try again after some time.');
    }

    log.error({ action: 'onNotReceived:Auth.forgotPassword:error', error: err });
    throw new Error('Could not send verification code.');
  });

  return true;
};
